import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TextInputModule } from '@liberty-financial/ng-components';
import { SparkSharedContactNumberComponent } from './generic/contact-number.component';
import { SparkSharedMobileNumberComponent } from './mobile/mobile-number.component';
import { SparkSharedPhoneNumberComponent } from './phone/phone-number.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, TextInputModule],
  declarations: [
    SparkSharedContactNumberComponent,
    SparkSharedMobileNumberComponent,
    SparkSharedPhoneNumberComponent
  ],
  exports: [
    SparkSharedContactNumberComponent,
    SparkSharedMobileNumberComponent,
    SparkSharedPhoneNumberComponent
  ]
})
export class SparkSharedContactNumberModule {}
